import { CONTENT } from "../shared/content";

function isDarioStage(levelIndex: number): boolean {
  return CONTENT.levels[levelIndex]?.id === "level03";
}

export const LEVEL03_BGM_KEY = "level03-gladiator-grid";
export const LEVEL03_BGM_URL = "/assets/audio/level03-gladiator-grid.mp3";
export const LEVEL03_BOSS_BGM_KEY = "level03-dario-boss";
export const LEVEL03_BOSS_BGM_URL = "/assets/audio/level03-dario-boss.mp3";
export const LEVEL03_FINAL_FORM_BGM_KEY = "level03-dario-final-form";
export const LEVEL03_FINAL_FORM_BGM_URL = "/assets/audio/level03-dario-final-form.mp3";
export const LEVEL03_BGM_VOLUME = 0.42;
export const LEVEL03_BGM_FADE_MS = 480;

export function shouldLoopLevel03Theme(input: {
  levelIndex: number;
  activeWaveId: string | null;
  practiceBossStart: boolean;
}): boolean {
  return (
    isDarioStage(input.levelIndex) &&
    input.activeWaveId !== "boss" &&
    !input.practiceBossStart
  );
}

export function shouldLoopLevel03BossTheme(input: {
  levelIndex: number;
  activeWaveId: string | null;
  practiceBossStart: boolean;
}): boolean {
  return (
    isDarioStage(input.levelIndex) &&
    (input.activeWaveId === "boss" || input.practiceBossStart)
  );
}

export function shouldLoopLevel03FinalFormTheme(input: {
  levelIndex: number;
  darioSecondForm?: boolean;
}): boolean {
  return isDarioStage(input.levelIndex) && input.darioSecondForm === true;
}
